<template>
  <div>
    <vs-button
      radius
      color="primary"
      type="border"
      size="small"
      :icon="icon"
      @click.stop="preview = !preview"
    ></vs-button>
    <action-timeline
      class="mt-6"
      v-if="preview"
      :automationId="automationId"
      :allowNewAction="false"
    />
  </div>
</template>

<script>
import ActionTimeline from "./ActionTimeline.vue";
export default {
  components: { ActionTimeline },
  name: "action-timeline-preview",
  props: ["automationId"],
  data() {
    return {
      preview: false,
    };
  },
  computed: {
    icon() {
      return this.preview ? "expand_less" : "expand_more";
    },
  },
};
</script>